import * as React from "react"
import {
  componentResolverFromMap,
  PrismicPreviewProvider,
} from "gatsby-plugin-prismic-previews"
import page from "./src/prismic/templates/page"
import resource from "./src/prismic/templates/resource"
import gallery from "./src/prismic/templates/gallery"
import showcase from "./src/prismic/templates/showcase"
import linkResolver from "./src/utils/link-resolver"
import { AuthProvider } from "./src/utils/context"

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider
    repositoryConfigs={[
      {
        repositoryName: process.env.GATSBY_PRISMIC_REPOSITORY_NAME,
        linkResolver,
        componentResolver: componentResolverFromMap({
          page,
          resource,
          gallery,
          showcase,
        }),
      },
    ]}
  >
    <AuthProvider>{element}</AuthProvider>
  </PrismicPreviewProvider>
)

const MAILERLITE_ACCOUNT_ID = "2143333"

const fetchMailerLiteForm = (formId, attempts = 0) => {
  const fn =
    window.ml && window.ml.fn && window.ml.fn.renderEmbeddedForm
  if (!fn) {
    if (attempts > 50) return
    setTimeout(() => fetchMailerLiteForm(formId, attempts + 1), 100)
    return
  }
  const script = document.createElement("script")
  script.src = `https://assets.mailerlite.com/jsonp/${MAILERLITE_ACCOUNT_ID}/forms/${formId}?callback=ml.fn.renderEmbeddedForm&_=${Date.now()}`
  script.async = true
  document.head.appendChild(script)
}

export const onRouteUpdate = () => {
  if (typeof window === "undefined") return

  const forms = document.querySelectorAll(".ml-embedded[data-form]")
  forms.forEach((el) => {
    const formId = el.getAttribute("data-form")
    if (formId) fetchMailerLiteForm(formId)
  })
}
